<template>
<modal name="addRespModal" transition="pop-out" :width="modalWidth" :height="300">
  <div class="modal__header">
      <h4>Add New Responsibility</h4>
  </div>
  <div class="cas_input">
      <div class="row__wrapper">
          <div class="row">
            <div class="col-md-12">
                <div class="" style="width: 100%">
                    <span>Responsibility Name</span>
                    <div class="">
                        <input type="text" placeholder="add responsibility here..." class="ml-3" v-model="name"  />
                    </div>
                </div>
            </div>
        </div>
      </div>
      
      <div class="text-center mt-4">
        <button class="creaet_branch_btn"
            @click="validateDetails($event)"
            :disabled="isButtonDisabled ? true : null"
            :style="[
            isButtonDisabled
                ? { cursor: 'not-allowed' }
                : { cursor: 'pointer' }
            ]">
            Add Responsibility  <i class="fa fa-save ml-2"></i>
            <span class="">
                <img src="@/assets/img/git_loader.gif" v-if="showLoader"  width="25px"/>
            </span>
        </button>
      </div>
  </div>
</modal>
</template>
<script>
const MODAL_WIDTH = 450;
import configObject from "@/config";

export default {
  name: 'addRespModal',
  data () {
    return {
      modalWidth: MODAL_WIDTH,
      name: null,
      isButtonDisabled:  false,
      showLoader: false,
      branch: this.$store.getters.getBranchdetail,
    }
  },
  created () {
    this.modalWidth = window.innerWidth < MODAL_WIDTH
      ? MODAL_WIDTH / 2
      : MODAL_WIDTH

  },
  methods: {
      validateDetails($event) {
        $event.preventDefault();
        if(!this.name){
            this.$toasted.show("Fill in the missing Fields", {
                    theme: "bubble",
                    position: "top-center",
                    duration: 2000
                });
        }else {
            this.addResponsibility();
        }
    },
    closeModal(){
        this.$modal.hide('addRespModal');
    },
    addResponsibility() {
        let dataToSend = {
            name: this.name,
        };
        this.showLoader = true;
        this.isButtonDisabled = true;
        this.axios.post(`${configObject.apiBaseUrl}/Responsibilities/Add`, dataToSend, configObject.authConfig)
            .then(() => {
                this.showLoader = false;
                this.isButtonDisabled = false;
                this.closeModal();
                this.$eventHub.$emit("refreshResponsilitiesTable");
                this.$toast.success("Responsiblity created successfully");
                this.name = null;
                })
                .catch((error) => {
                    this.isButtonDisabled = false;
                    this.showLoader = false;
                    this.$toast.open({
                        message: "unable to add responsibility",
                        type: "error",
                        duration: 3000
                    });
                    console.log(error);
            });
    },
  }
}
</script>
